import useFetch from '@hooks/useFetch';
import { getIsLoggedIn } from '@api/selectors/auth';
import useMyInfo from '../auth/useMyInfo';

const useNotifiedList = (educatorUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { data, mutate } = useFetch(
    isLoggedIn
      ? `sheldon/v1/user/notified-programmes?educator_uid=${educatorUID}`
      : null,
    undefined,
    {
      revalidateOnMount: true,
      dedupingInterval: 2 * 60 * 60 * 1000
    }
  );

  const formattedNotifiedList = (data || []).reduce(
    (acc, curr) => ({ ...acc, [curr]: true }),
    {}
  );

  return {
    notifiedProgrammes: formattedNotifiedList,
    refetchNotifiedProgrammes: mutate
  };
};

export default useNotifiedList;
